import { Button } from "antd";
import {GoogleOutlined} from '@ant-design/icons'
import { auth,provider,db} from "../Config";
import {signInWithPopup,getAdditionalUserInfo} from 'firebase/auth'
import {doc,setDoc} from 'firebase/firestore'
import { useNavigate } from "react-router-dom";
import './Login.css'
export default function Login(){
    let navigate = useNavigate()
    const handleLogin = async()=>{
        const result = await signInWithPopup(auth, provider);
        const details = getAdditionalUserInfo(result);
        if (details.isNewUser){
            setDoc(doc(db, 'users', result.user.uid), {
                uid: result.user.uid,
                userName: result.user.displayName,
                email: result.user.email,
                avt:result.user.photoURL,
                name:'',
                phone:'',
                city:'',
                district:'',
                wards:'',
                address:'',
                fullInfo:false,
            });
        }  
        navigate('/home')
    }
    return(
        <div className="login-field">
            <h1 to='/' style={{color:'black',textDecoration:'none',fontFamily:'Kaushan Script, cursive',fontSize:'4vmax'}}>MeStore</h1>
            <button className="login-btn" onClick={handleLogin}><GoogleOutlined style={{marginRight:'0.5vw'}}/>Đăng Nhập với Google</button>
        </div>
    )
}